<template>
  <div>
    <Nav />
    <Banner />
    <div style="margin: auto; width: 1250px">
      <img style="width: 100%" src="../../assets/images/home2.png" alt="" />
    </div>
    <div style="
        margin: auto;
        width: 100%;
        background-color: rgba(233, 233, 233, 0.89);
      ">
      <div class="jianshao">
        <h2 class="one">走进诉和调解中心</h2>
        <h3 class="tow">ABOUT SUHE MEDIATION CENTER</h3>
        <div class="df">
          <div class="df_l">
            <img src="../../assets/images/公司图片.png" alt="" />
          </div>
          <div class="df_r">
            <div class="df_title">2015年起，扎根郑州航空港区，专注多元解纷服务。</div>
            <div class="di_tent">
              <div>
                地址：河南郑州市金水区博学路街道东风南路与创业路交叉口东北方向100米绿地之窗云峰座A座8楼807。
              </div>
              <div>
                我们秉持“依法调解、平等自愿、便民高效”的原则，为社会公众与市场主体提供专业、规范、可靠的纠纷解决服务。业务覆盖民商事纠纷调解、刑事附带民事纠纷中民事部分调解，并延伸至民商事纠纷咨询、法律宣传、专业培训与理论研究。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="app-section">
      <div class="app-inner">
        <section class="hero-section">
          <div class="hero-main">
            <h2 class="hero-title">诉和调解平台 App</h2>
            <p class="hero-value">为个人与企业提供高效、可信、可追踪的一站式线上调解服务入口。</p>
            <p class="hero-positioning">一句话定位：面向纠纷处理场景，提供“申请—调解—跟进”全流程线上化能力，降低沟通与时间成本。</p>
            <div class="hero-cta">
              <a class="app-link primary" :href="officialWebsiteUrl" target="_blank" rel="noopener noreferrer">立即下载</a>
            </div>
          </div>
          <div class="hero-media">
            <div class="hero-media-card">
              <video controls muted autoplay loop playsinline preload="metadata" poster="../../assets/images/home2.png">
                <source :src="require('../../assets/images/b86e9e0b48582c78999c1f2ad5448ad7.mp4')" type="video/mp4" />
                您的浏览器暂不支持视频播放。
              </video>
            </div>
          </div>
        </section>

        <section class="decision-section">
          <h3>决策型信息</h3>

          <div class="scene-box">
            <h4>场景化描述</h4>
            <p>
              适用于“合同履约争议、服务纠纷、付款分歧”等场景。用户可在线提交申请、上传材料、预约远程参与并查看进度，避免线下反复沟通。
              对个人用户而言更省时，对企业用户而言更易标准化协同与留痕。
            </p>
          </div>

          <div class="spec-box">
            <h4>技术 / 参数</h4>
            <table class="spec-table">
              <tr>
                <th>参数项</th>
                <th>说明</th>
              </tr>
              <tr>
                <td>系统要求</td>
                <td>Android 8.0+ / iOS 13.0+ / 现代浏览器</td>
              </tr>
              <tr>
                <td>核心权限</td>
                <td>相机（材料拍照）、相册（附件上传）、通知（进度提醒）</td>
              </tr>
              <tr>
                <td>接口能力</td>
                <td>支持材料上传、进度回执、消息通知</td>
              </tr>
              <tr>
                <td>性能指标</td>
                <td>首页打开 ≤ 2 秒（4G 网络环境目标）</td>
              </tr>
            </table>
          </div>

          <div class="faq-box">
            <h4>FAQ（高频问题）</h4>
            <details>
              <summary>下载失败怎么办？</summary>
              <p>请检查网络环境、存储空间与系统版本，建议通过官网提供的官方入口重新下载。</p>
            </details>
            <details>
              <summary>安装后无法登录？</summary>
              <p>请先确认手机号是否已注册，若忘记密码可通过短信验证码重置。</p>
            </details>
            <details>
              <summary>为什么需要相机/相册权限？</summary>
              <p>用于拍摄或上传申请材料，仅在对应功能中调用，不会超范围采集。</p>
            </details>
            <details>
              <summary>是否支持退款或撤回申请？</summary>
              <p>具体以服务协议与案件阶段为准，建议在“我的申请”内查看并联系人工客服。</p>
            </details>
          </div>

          <div class="log-box">
            <h4>更新日志</h4>
            <ul>
              <li>v1.2.0｜2026-03-28｜新增进度提醒中心｜用户可更早感知节点变化，减少遗漏</li>
              <li>v1.1.0｜2026-02-10｜优化申请引导与表单校验｜提交成功率提升，减少反复填写</li>
              <li>v1.0.3｜2026-01-05｜修复附件上传偶发失败问题｜提高稳定性与可用性</li>
            </ul>
          </div>
        </section>

      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Banner from "./components/Banner";
import { getAllCertificates, getFooterData } from "@/api/index"; // 引入API方法
export default {
  name: "Home",
  components: {
    Banner, // 轮播图
  },
  props: {},
  watch: {},
  data() {
    return {
      homeTitle: "",
      homeDescription: "",
      hotlineVisible: false, // 服务支持弹窗
      certificates: [], // 存储证书数据
      qrCodeVisible: false,
      footerData: null,
      officialWebsiteUrl: "https://suhe.ying-guang.com/download",
      androidStoreUrl: "https://www.example.com/android",
      iosStoreUrl: "https://apps.apple.com/app/id0000000000",
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    }, 0);
  },
  created() { },
  methods: {
    navigateTo(url) {
      // window.location.href = url;
      this.$router.push(url);
    },
    showHotline() {
      this.hotlineVisible = true;
    },
    copyToClipboard(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    async fetchCertificates() {
      try {
        const response = await getAllCertificates();
        this.certificates = response.data;
      } catch (error) {
        console.error("Failed to fetch certificates:", error);
      }
    },
    async fetchHomeData() {
      try {
        const response = await getFooterData();
        // console.log("response", response);
        if (response && response.data) {
          this.homeTitle = response.data[0].homeTitle || "XXXXXXXXXXXXXXXX";
          this.homeDescription =
            response.data[0].homeDescription ||
            "一个XXXXXXXXXX、经典、文化的深度用户";
        }
      } catch (error) {
        console.error("获取首页数据失败:", error);
      }
    },
    showQRCode() {
      this.qrCodeVisible = true;
    },
    async fetchFooterData() {
      try {
        const response = await getFooterData();
        if (response && response.data && response.data.length > 0) {
          this.footerData = response.data[0];
        }
      } catch (error) {
        console.error("获取页脚数据失败:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hotline-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hotline-text {
  font-size: 18px;
  /* Increase font size */
  user-select: text;
  /* Make text selectable */
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; // Ensure the page takes at least the full height of the viewport
  padding: 20px;
  margin-top: 75px; // 添加这一行

  @media (max-width: 768px) {
    padding: 10px;
    margin-top: 60px; // 在移动设备上调整这个值
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
}

.container {
  flex: 1; // Allow the container to grow and fill available space
  margin-bottom: 100px; // Add space between container and footer
}

.introduce {
  margin: 20px 0;
  text-align: center;
}

.center {
  text-align: center;
}

.about-us {
  margin: 40px 0;
  text-align: center;

  h2 {
    font-size: 24px;
    margin-bottom: 20px;
    position: relative;
  }

  h2::after {
    content: "";
    display: block;
    width: 50px;
    height: 2px;
    background: red;
    margin: 10px auto 0;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 40px;
  }
}

.features {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  .feature {
    width: 200px;
    text-align: center;
    margin-bottom: 20px;

    .feature-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

/* 新增样式 */
.info-services {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 20px 0;

  .service {
    width: 200px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.05);
    }

    .service-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

.full-image {
  width: 100%;
  height: 100%;
  object-fit: cover; // 保持图片的宽高比并裁剪以填充容器
}

.scrolling-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  position: relative;
}

.scrolling-content {
  display: inline-block;
  animation: scroll 20s linear infinite;
  text-align: center;
  margin: 0 10px;
}

.certificate-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .scrolling-content {
    animation: scroll 10s linear infinite;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.jianshao {
  padding: 30px 0;
  margin: auto;
  width: 1250px;

  .one {
    margin-bottom: 10px;
    color: #000;
  }

  .tow {
    color: rgba(69, 74, 91, 0.2);
    margin-bottom: 10px;
  }

  .df {
    display: flex;

    .df_l {
      width: 50%;
    }

    .df_r {
      width: 50%;

      .df_title {
        font-size: 18px;
        font-weight: 700;
        color: #333;
        margin-bottom: 20px;
      }

      .di_tent {
        text-indent: 2em;

        div {
          margin-bottom: 10px;
        }
      }
    }
  }
}

.app-section {
  padding: 50px 0;
  background: rgba(233, 233, 233, 0.35);
}

.app-inner {
  width: 1250px;
  margin: 0 auto;

  h2 {
    margin-bottom: 12px;
    font-size: 30px;
    color: #1f2d3d;
  }

  .app-desc {
    margin-bottom: 26px;
    color: #606266;
    line-height: 1.8;
    max-width: 920px;
  }
}

.hero-section {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 24px;
  padding: 30px;
  border-radius: 18px;
  background:
    radial-gradient(1200px 500px at 0% 0%, rgba(45, 108, 223, 0.14), transparent 55%),
    radial-gradient(900px 420px at 100% 10%, rgba(64, 158, 255, 0.12), transparent 55%),
    #fff;
  box-shadow:
    0 10px 32px rgba(0, 0, 0, 0.08),
    0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 22px;
  overflow: hidden;
}

.hero-title {
  letter-spacing: 0.2px;
  margin-bottom: 12px;
}

.hero-value,
.hero-positioning {
  color: #606266;
  line-height: 1.8;
  margin-bottom: 10px;
}

.hero-value {
  font-size: 15px;
}

.hero-positioning {
  font-size: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(64, 158, 255, 0.08);
  border: 1px solid rgba(64, 158, 255, 0.18);
}

.hero-cta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.hero-media {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-media-card {
  width: 100%;
  max-width: 520px;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.22), rgba(0, 0, 0, 0.12));
  padding: 10px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(31, 45, 61, 0.08);
}

.hero-media-card video {
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: 320px;
  border-radius: 12px;
  background: #000;
  display: block;
  object-fit: contain;
}

.review-base-section,
.decision-section,
.structure-section {
  margin-top: 22px;
  padding: 22px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  h3 {
    margin-bottom: 14px;
    font-size: 24px;
    color: #1f2d3d;
  }

  h4 {
    margin-bottom: 10px;
    font-size: 18px;
    color: #303133;
  }
}

.base-grid,
.feature-grid,
.trust-grid,
.structure-grid {
  display: grid;
  gap: 14px;
}

.base-grid,
.feature-grid,
.trust-grid {
  grid-template-columns: repeat(2, 1fr);
}

.base-card,
.feature-item,
.trust-item,
.structure-grid>div,
.scene-box,
.spec-box,
.faq-box,
.log-box {
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 14px;
  background: #fff;
}

.base-card ul,
.log-box ul,
.more-content ul,
.more-content ol {
  margin: 0;
  padding-left: 20px;
  line-height: 1.8;
  color: #606266;
}

.scene-box p,
.faq-box p,
.more-content {
  line-height: 1.8;
  color: #606266;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ebeef5;
    padding: 10px;
    text-align: left;
    font-size: 14px;
    color: #606266;
  }

  th {
    background: #f5f7fa;
    color: #303133;
  }
}

.faq-box details {
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

.more-box {
  margin-top: 16px;
  border: 1px dashed #dcdfe6;
  border-radius: 10px;
  padding: 10px 12px;
}

.app-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 18px;
  border: 1px solid rgba(64, 158, 255, 0.55);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.85);
  color: #409eff;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 6px 14px rgba(64, 158, 255, 0.12);

  &:hover {
    color: #fff;
    background: #409eff;
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(64, 158, 255, 0.22);
  }

  &.primary {
    color: #fff;
    background: linear-gradient(135deg, #2d6cdf, #409eff);
    border: 1px solid rgba(45, 108, 223, 0.9);
  }

  &.disabled {
    border: 1px solid #e6e8f0;
    background: #f7f8fa;
    color: #b9bdc7;
  }
}

@media (max-width: 1280px) {

  .app-inner,
  .jianshao {
    width: 94%;
  }
}

@media (max-width: 900px) {
  .hero-section {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .hero-media-card {
    max-width: 100%;
  }

  .hero-media-card video {
    max-height: 360px;
  }

  .base-grid,
  .feature-grid,
  .trust-grid,
  .structure-grid {
    grid-template-columns: 1fr;
  }

  .review-base-section,
  .decision-section,
  .structure-section {
    padding: 16px;

    h3 {
      font-size: 20px;
    }
  }

  .jianshao .df {
    flex-direction: column;

    .df_l,
    .df_r {
      width: 100%;
    }
  }
}
</style>